import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtErr } from "../lib/api";
import { Button, Card, Input, Label, Section, TH, TD, Empty, Badge } from "../components/ui";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function CompaniesPage() {
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: "", zoho_organization_id: "",
    zoho_base_url: "https://www.zohoapis.eu/invoice/v3",
    zoho_cif_custom_field: "", fd_company_id: "",
    fd_base_url: "https://app.facturadirecta.com",
  });

  const load = async () => {
    const { data } = await api.get("/companies");
    setList(data);
  };
  useEffect(() => { load(); }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/companies", form);
      toast.success("Società creata");
      setShowForm(false);
      setForm({ ...form, name: "" });
      load();
    } catch (e) { toast.error(fmtErr(e.response?.data?.detail) || e.message); }
  };

  return (
    <div className="space-y-6" data-testid="companies-page">
      <Section
        title="Società"
        subtitle="Configurazione delle società bridge Zoho → FacturaDirecta"
        action={<Button onClick={() => setShowForm((v) => !v)} data-testid="btn-new-company"><Plus size={16} className="mr-1.5" /> Nuova società</Button>}
      >
        {showForm && (
          <Card className="p-6">
            <form onSubmit={onSubmit} className="grid grid-cols-2 gap-4">
              <div className="col-span-2"><Label>Nome società *</Label>
                <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="input-company-name" /></div>
              <div><Label>Zoho Organization ID</Label>
                <Input value={form.zoho_organization_id} onChange={(e) => setForm({ ...form, zoho_organization_id: e.target.value })} data-testid="input-zoho-org-id" /></div>
              <div><Label>Zoho Base URL</Label>
                <Input value={form.zoho_base_url} onChange={(e) => setForm({ ...form, zoho_base_url: e.target.value })} data-testid="input-zoho-base-url" /></div>
              <div><Label>Custom field CIF</Label>
                <Input placeholder="cif" value={form.zoho_cif_custom_field} onChange={(e) => setForm({ ...form, zoho_cif_custom_field: e.target.value })} data-testid="input-cif-field" /></div>
              <div><Label>FacturaDirecta Company ID</Label>
                <Input value={form.fd_company_id} onChange={(e) => setForm({ ...form, fd_company_id: e.target.value })} data-testid="input-fd-company-id" /></div>
              <div className="col-span-2"><Label>FacturaDirecta Base URL</Label>
                <Input value={form.fd_base_url} onChange={(e) => setForm({ ...form, fd_base_url: e.target.value })} /></div>
              <div className="col-span-2 flex justify-end gap-2">
                <Button type="button" variant="secondary" onClick={() => setShowForm(false)}>Annulla</Button>
                <Button type="submit" data-testid="btn-save-company">Crea società</Button>
              </div>
            </form>
          </Card>
        )}

        <Card className="overflow-hidden">
          <table className="w-full">
            <thead className="border-b border-border-default bg-surface-hover/50">
              <tr><TH>Nome</TH><TH>Stato</TH><TH>Zoho Org ID</TH><TH>FD Company ID</TH><TH>Policy</TH><TH></TH></tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id} className="border-b border-border-divider table-row-hover">
                  <TD className="font-medium">{c.name}</TD>
                  <TD>{c.is_active ? <Badge tone="success">Attiva</Badge> : <Badge>Disattiva</Badge>}</TD>
                  <TD className="font-mono text-xs">{c.zoho_organization_id || "—"}</TD>
                  <TD className="font-mono text-xs">{c.fd_company_id || "—"}</TD>
                  <TD className="text-xs">{c.post_export_policy}</TD>
                  <TD><Link className="underline" to={`/companies/${c.id}`} data-testid={`link-detail-${c.id}`}>Apri →</Link></TD>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan={6}><Empty>Nessuna società. Crea la prima.</Empty></td></tr>}
            </tbody>
          </table>
        </Card>
      </Section>
    </div>
  );
}
